import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { ModalContent } from "../ModalContent";
import { SectionLeft } from "../SectionLeft";
import { ContentDescription } from "../ContentDescription";
import { GelContentsBlock } from "../GelContentsBlock";
import { SectionRight } from "../SectionRight";
import { GelLaneSelect } from "../GelLaneSelect";
import { GelLaneDeposit } from "../GelLaneDeposit";
import { GelLanePipette } from "../GelLanePipette";
import { OrientationStatusBlock } from "../OrientationStatusBlock";
import { GelLabTip } from "../GelLabTip";
import { ModalViewControls } from "../ModalViewControls";
import { FullscreenModal } from "@learningblocks/storybook-components/lib/FullscreenModal";

import "./style.scss";

const VIEWS = [{ TOP_VIEW: "TOP_VIEW" }, { SIDE_VIEW: "SIDE_VIEW" }];
export function GelPipetteModal(props) {
  const { t } = useTranslation();

  const [selectedLane, setSelectedLane] = React.useState(null);
  const [currentView, setCurrentView] = React.useState("TOP_VIEW");

  React.useEffect(() => {
    if (!props.isOpen) {
      setSelectedLane(null);
      setCurrentView("TOP_VIEW");
    }
  }, [props.isOpen]);

  return (
    <FullscreenModal
      isOpen={props.isOpen}
      size={props.size}
      className="gel_pipette_modal"
      close={props.onClose}
      closeButton={true}
      notebookExpanded={props.notebookExpanded}
      lang={props.lang}
    >
      <div className="controlsModal">
        <ModalContent className="controlsModal_content">
          {currentView === "TOP_VIEW" ? (
            <>
              <SectionLeft className="controlsModal_content_left">
                <ModalViewControls
                  views={VIEWS}
                  currentView={currentView}
                  setCurrentView={setCurrentView}
                  selectedLane={selectedLane}
                />
                <div className="controlsModal_content_left_wrapper">
                  <ContentDescription
                    className="controlsModal_content_left_contentDescription"
                    title={t("SelectLaneInstruction.string")}
                    description=""
                  />
                  <OrientationStatusBlock
                    orientation={props.orientation}
                    className="controlsModal_content_left_contents"
                    lanes={props.lanes}
                  />
                  <GelContentsBlock
                    lanes={props.lanes}
                    selectedLane={selectedLane}
                    className="controlsModal_content_left_contents"
                  />
                </div>
              </SectionLeft>
              <SectionRight className="controlsModal_content_right">
                <GelLaneSelect
                  className="controlsModal_content_right_panel_top"
                  lanes={props.lanes}
                  selectedLane={selectedLane}
                  setSelectedLane={setSelectedLane}
                  setGelActiveLane={props.setGelActiveLane}
                  alert={props.alert}
                  orientation={props.orientation}
                />
              </SectionRight>
            </>
          ) : null}
          {currentView === "SIDE_VIEW" ? (
            <>
              <SectionLeft className="controlsModal_content_left">
                <ModalViewControls
                  views={VIEWS}
                  currentView={currentView}
                  setCurrentView={setCurrentView}
                  selectedLane={selectedLane}
                />
                <div className="controlsModal_content_left_wrapper">
                  <ContentDescription
                    className="controlsModal_content_left_contentDescription"
                    title={t("DispenseSolution.string")}
                    description=""
                  />
                  <GelLabTip className="controlsModal_content_left_contents" />
                  <GelLanePipette
                    className="controlsModal_content_left_contents"
                    pipetteId={props.pipetteId}
                    interactionProps={props.interactionProps}
                    lanes={props.lanes}
                    selectedLane={selectedLane}
                    setGelLane={props.setGelLane}
                    setPipetteSolution={props.setPipetteSolution}
                    alert={props.alert}
                    setSelectedLane={setSelectedLane}
                  />
                </div>
              </SectionLeft>
              <SectionRight className="controlsModal_content_right">
                <GelLaneDeposit
                  className="controlsModal_content_right_panel_side"
                  lanes={props.lanes}
                  selectedLane={selectedLane}
                  alert={props.alert}
                  pipetteId={props.pipetteId}
                  interactionProps={props.interactionProps}
                />
              </SectionRight>
            </>
          ) : null}
        </ModalContent>
      </div>
    </FullscreenModal>
  );
}

GelPipetteModal.propTypes = {
  /**
   * Function to alert event
   */
  alert: PropTypes.func,
  /**
   * Boolen to set if modal is displayed
   */
  isOpen: PropTypes.bool,
  /**
   * Function to invoke to close the modal
   */
  onClose: PropTypes.func,
  /**
   * Boolean to set if the Microcentrifuge tubes are balanced
   */
  balanced: PropTypes.bool,
  /**
   * Current rpm value set
   */
  rpmValue: PropTypes.number,
  /**
   * Current Runtime set
   */
  timeValue: PropTypes.instanceOf(Date),
  /**
   * Time left for centrifuge to run to completion
   */
  timeLeft: PropTypes.instanceOf(Date),
  /**
   * Function to set RPM value
   */
  setRPM: PropTypes.func,
  /**
   * Function to set Run Time
   */
  setTimeValue: PropTypes.func,
  /**
   * Function to invoke when to  run the Centrifuge
   */
  runCentrifuge: PropTypes.func,
  /**
   * Boolean to determine if centrifuge runnable
   */
  centrifugeRunnable: PropTypes.bool,
};

GelPipetteModal.defaultProps = {
  showClose: true,
  size: "md",
};
